import Vue from "vue";
import { EventBus } from "@/services/EventBus";

export default class {
  constructor() {
    this.v = "v1";
  }

  get(url, options = {}) {
    return Vue.http.get("/api/" + this.v + "/" + url, options).then(
      r => {
        return r.body.data;
      },
      r => {
        if (r.status !== 400) {
          EventBus.$emit("error", {
            message: "global.temporarilyUnavailable",
            code: r.status
          });
        }

        return Promise.reject(r);
      }
    );
  }

  getImage(url, options = {}) {
    return Vue.http.get(url, options).then(r => {
      let urlCreator = window.URL || window.webkitURL;

      return urlCreator.createObjectURL(r.bodyBlob);
    });
  }

  getCams() {
    return this.get("cameras");
  }

  getCam(id) {
    return this.get("cameras/" + id);
  }

  getCamImage(id) {
    return this.getImage(
      "/api/v2/cameras/" + encodeURIComponent(id) + "/image",
      {
        responseType: "blob"
      }
    );
  }

  getMapImage(mapId, planId) {
    return this.getImage("/api/v1/maps/" + mapId + "/image/" + planId, {
      responseType: "blob"
    });
  }

  getMaps() {
    return this.get("maps");
  }

  getMap(mapGroupId) {
    return this.get(`maps/${mapGroupId}`);
  }

  getPage(name) {
    return Vue.http.get("/static/pages/" + name + ".html").then(r => {
      return r.body;
    });
  }

  getAcsObject(type, id) {
    return new Promise(resolve => {
      this.get(`acsconfig?type=${type}&ids=${id}`)
        .then(r => {
          resolve(r[0]);
        })
        .catch(e => {
          resolve(null);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/services/ApiService.js